import React from 'react';
import { Platform } from 'react-native';

interface IProps {
    children: React.ReactNode;
    calssNames?: string;
}

export const HideScrollBarOnWeb = ({children, className}: IProps) => {
    return Platform.OS === 'web' ? (
      <div className={`hide-scroll-bar ${className}`}>{children}</div>
    ) : (
      <>{children}</>
    );
};
